export const setColorTheme = () => {
  document.body.classList.add('dark', 'forchat-theme');
  document.documentElement.style.setProperty('color-scheme', 'dark');
};
